import BaseListPresenter from "../../base/BaseListPresenter";
import Papa from "papaparse";

class TransactionPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    this.limit = 300;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
      count: true,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      if (Object.keys(this.filter).length === 0) {
        this.view.setState({ loading: false });
      } else {
        this.objects = this.objects.concat(objects);
        this.view.setTotal(this.objects.length);
        this.view.setObjects(this.objects);
        this.view.setFilter(false);
        this.hideProgress();
      }
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  filterSubmit(where) {
    this.view.setState({ filter: true });
    this.reset();
    this.filter = where;
    this.getObjects();
  }

  async onClickExport() {
    const objects = this.view.getSelected();
    const collection = this.view.getCollectionName();

    if (objects.length === 0) {
      console.log("No objects selected for export.");
      return;
    }

    // Define the sequence of columns you want
    const fields = [
      "id",
      "store_id",
      "tran_id",
      "tran_date",
      "status",
      "tran_type",
      "remarks",
      "discount_id",
      "discount",
      "discount_am",
      "discount_nar",
      "user_id",
      "reason",
      "total",
      "total_pretax",
      "total_tax",
      "paymenttype",
      "cust_count",
      "total_tender",
      "total_change",
      "taxfree",
      "changes",
      "cust_name",
      "cust_address",
      "cust_phone",
      "cust_mobile",
      "cust_barangay",
      "cust_notes",
      "cust_card",
      "cust_email",
      "cust_birthday",
      "landmark",
      "apcnumber",
      "deltime",
      "items",
      "store_code",
      "cod",
      "window",
      "zyllem",
      "createdAt",
      "updatedAt",
      "acl",
      "paymenttypetotal",
      "paymenttype2",
      "paymenttype2total",
      "paymenttype3",
      "paymenttype3total",
      "reopen",
      "reopen_user_id",
      "date_close",
    ];

    // Now use Papa.unparse with `fields`
    const csv = Papa.unparse(objects, { columns: fields });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${collection}_export.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
export default TransactionPresenter;
